// TODO Package candidate
// eslint-disable-next-line @tseslint/typedef
export const HTTP_HEADER_NAMES = {
  /** MIME type of the response content, e.g., 'application/json' */
  contentType: 'Content-Type',
  /** Size of the response body in bytes */
  contentLength: 'Content-Length',
  /** URL of newly created resource (201 Created) */
  location: 'Location',
  /** Caching directives */
  cacheControl: 'Cache-Control',
  /** Unique identifier for a resource version, useful for caching */
  eTag: 'ETag',
  /** Date/time when the resource was last modified */
  lastModified: 'Last-Modified',
  /** Date/time when the response was generated */
  date: 'Date',
  /** Server software handling the request */
  server: 'Server',
  /** Connection options, e.g., 'keep-alive' */
  connection: 'Connection',
  /** Allowed origins for cross-origin requests (CORS) */
  accessControlAllowOrigin: 'Access-Control-Allow-Origin',
  /** How a client should authenticate (401 responses) */
  wwwAuthenticate: 'WWW-Authenticate',
  /** Used to set cookies on the client */
  setCookie: 'Set-Cookie',
  /** Optional request tracing/debugging */
  xRequestId: 'X-Request-Id',
  /** How long to wait before retrying (429/503) */
  retryAfter: 'Retry-After'
} as const;
